import "./ActiveElectionsSummaryPanel.scss";
import { useContext } from "react";
import { ThemeContext } from "../../../../common/theme/ThemeContext";
import { Link } from "react-router-dom";
import Icon from "@mdi/react";
import { mdiBallotRecountOutline, mdiFileExportOutline, mdiAccountPlusOutline } from "@mdi/js";
import CountdownTimer from "../CountdownTimer";
import Tooltip from "../../../../common/tooltip/Tooltip";
import { faLock } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFile } from "@fortawesome/free-regular-svg-icons";
import { MessageContext } from "../../../../common/message";
import { getAccessToken } from "../../../../common/authorization/AuthorizeService";
import { useTranslation } from "react-i18next";

const ActiveElectionsSummaryPanel = ({
  election,
  index,
  noElections = false,
  setFetchElections,
}) => {
  const { t } = useTranslation();
  const theme = useContext(ThemeContext);
  const message = useContext(MessageContext);
  let totalNumberOfVoters = election.registerVoters
    ? `Ukupno ${election.registerVoters} registriranih glasača`
    : "Nema registriranih glasača";
  let electionsPanelThemeColor;
  let bottomBorderColor;
  let widgetDate;
  let cancellationFileName;
  let countdownTitle = "Preostalo vrijeme do početka glasovanja";

  switch (election.generatedStatus.id) {
    case 1:
      electionsPanelThemeColor = theme.iconColor;
      bottomBorderColor = "rgba(125, 101, 142, 1)";
      widgetDate = new Date(election.dateTimeVotingStart);
      break;
    case 2:
      electionsPanelThemeColor = theme.iconColor;
      bottomBorderColor = "rgba(125, 101, 142, 1)";
      widgetDate = new Date(election.dateTimeVotingStart);
      break;
    case 3:
      electionsPanelThemeColor = theme.voteGreen;
      bottomBorderColor = "rgba(74, 144, 89, 255)";
      widgetDate = new Date(election.dateTimeVotingEnd);
      countdownTitle = "Preostalo vrijeme do završetka glasovanja";
      break;
    case 4:
      electionsPanelThemeColor = theme.voteRed;
      bottomBorderColor = "rgba(169, 66, 83, 255)";
      widgetDate = new Date(election.dateTimeVotingEnd);
      break;
    case 5:
      electionsPanelThemeColor = theme.voteGrey;
      bottomBorderColor = "rgba(162, 161, 163, 255)";
      widgetDate = new Date(election.dateOfCancellation);
      if (election?.cancellationFileUrl) {
        cancellationFileName = election.cancellationFileUrl?.split("_user_")[1];
      }
      break;
    default:
      electionsPanelThemeColor = theme.voteGrey;
      bottomBorderColor = "rgba(162, 161, 163, 255)";
      widgetDate = new Date(election.dateTimeVotingStart);
      break;
  }

  const dateNow = new Date();
  let day = widgetDate.getDate();
  let month = widgetDate.getMonth() + 1;
  let year = widgetDate.getFullYear();

  let date = `${day}.${month}.${year}`;

  if (date === "1.1.1970") {
    date = ""; // Ako "dateTimeVotingStart" nije unesen u izbore, prikazivati prazno
  }

  // uses server time instead of local.
  let nowServer = new Date(election.serverDate);
  //client time
  let nowClient = new Date();
  let currentTimeOffset = nowServer - nowClient;

  const getFileFromServer = async (fileUrl) => {
    message.toggle({
      show: true,
      title: "",
      content: t("requests.wait.label"),
      hideNo: true,
      hideYes: true,
      isWait: true,
      hideX: false,
    });
    fetch(`${process.env.REACT_APP_GATEWAY_URL}${fileUrl}`, {
      method: "GET",
      headers: {
        "Request-Origin": "pisarnica",
        Authorization: "Bearer " + (await getAccessToken()),
      },
      mode: "cors",
      credentials: "include",
    })
      .then((response) => response.blob())
      .then((file) => window.open(URL.createObjectURL(file)) && message.toggle({ show: false }));
  };

  if (noElections) {
    return (
      <div className={`mt-6 mb-6`}>
        <div
          style={{
            width: "65%",
            borderBottom: `4px solid ${bottomBorderColor}`,
            boxShadow:
              "rgba(14, 30, 37, 0.12) 0px 2px 4px 0px, rgba(14, 30, 37, 0.32) 0px 2px 16px 0px",
            borderRadius: "5px",
            margin: "0 auto",
          }}
        >
          <div className="is-flex is-justify-content-center is-align-self-center p-6">
            <h3>Trenutno nema aktivnih izbora </h3>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div key={index} className={`mt-6 mb-6`}>
        <div
          style={{
            width: "65%",
            borderBottom: `4px solid ${bottomBorderColor}`,
            boxShadow:
              "rgba(14, 30, 37, 0.12) 0px 2px 4px 0px, rgba(14, 30, 37, 0.32) 0px 2px 16px 0px",
            borderRadius: "5px",
            margin: "0 auto",
          }}
        >
          <Link
            to={{
              pathname: "/elections/new",
              state: {
                id: election.id,
                electionGeneratedStatus: election.generatedStatus.id,
              },
            }}
          >
            <div style={{ width: "100%", height: "75px" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  height: "100%",
                }}
                className="mt-4 mr-5 ml-6"
              >
                <div className="is-size-4 is-flex is-align-items-center">
                  <span className={`has-text-${electionsPanelThemeColor} has-text-weight-bold `}>
                    {election.generatedStatus.status}
                  </span>
                  <span style={{ color: "#4a4a4a" }}>&nbsp;{"-"}&nbsp;</span>
                  <div
                    className="voting-details-link"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginRight: "10px",
                    }}
                  >
                    {election.typeName}
                    {election.generatedStatus.id === 2 ? (
                      <div className="ml-4">
                        <Tooltip
                          content={"Izbori su zaključani"}
                          children={
                            <FontAwesomeIcon
                              icon={faLock}
                              // size="1.2x"
                              style={{ fontSize: "2rem" }}
                              className={`has-text-${theme.iconColor}`}
                            />
                          }
                        ></Tooltip>
                      </div>
                    ) : null}
                  </div>
                </div>
                <div
                  className={`is-flex is-align-items-center has-text-weight-bold is-size-4 has-text-${electionsPanelThemeColor}`}
                >
                  <p style={{ textAlign: "center" }}>{date} </p>
                </div>
              </div>
            </div>
            {/* Drugi panel*/}
            <div style={{ width: "100%", height: "35px" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  height: "100%",
                }}
                className="mt-4 mr-6 ml-6"
              >
                <div className="is-flex is-justify-content-center is-align-items-center">
                  {election.cancellationFileUrl ? (
                    <>
                      <div className="is-size-5 has-text-weight-bold has-text-danger">
                        Dokument o otkazivanju
                      </div>
                      <div className="ml-2">
                        <Tooltip
                          key={index}
                          content={cancellationFileName}
                          children={
                            <div
                              onClick={(e) => {
                                e.preventDefault();
                                getFileFromServer(election.cancellationFileUrl);
                              }}
                              className="file-icon-div"
                            >
                              <FontAwesomeIcon
                                key={index}
                                icon={faFile}
                                className="is-size-4 ml-1"
                              />
                            </div>
                          }
                        ></Tooltip>
                      </div>
                    </>
                  ) : null}
                </div>
                <div className="is-size-6 is-flex is-align-items-center"></div>
                <div className="is-flex is-justify-content-center is-align-items-center">
                  <span className="ml-4">
                    {election.generatedStatus.id === 4 || election.generatedStatus.id === 3 ? (
                      <Link
                        to={{
                          pathname: "/elections/results",
                          state: {
                            id: election.id,
                            typeName: election.typeName,
                            generatedId: election.generatedStatus.id,
                          },
                        }}
                      >
                        <Tooltip
                          content={"Rezultati izbora"}
                          delay={"0"}
                          direction={"top"}
                          children={
                            <Icon
                              style={{ color: "RGB(185,73,91)" }}
                              path={mdiBallotRecountOutline}
                              size={2.3}
                            />
                          }
                        ></Tooltip>
                      </Link>
                    ) : null}
                  </span>
                </div>
              </div>
            </div>
            {/* Treci panel*/}
            <div style={{ width: "100%", height: "75px" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  height: "100%",
                }}
                className="mt-4 mr-5 ml-6"
              >
                <div className="is-flex is-justify-content-center is-align-items-center">
                  <span style={{ color: "#4a4a4a" }} className={`has-text-weight-bold`}>
                    {totalNumberOfVoters}
                  </span>
                  <span className="ml-3">
                    <Tooltip
                      content={"Izvezi migrirane članove"}
                      delay={"0"}
                      direction={"top"}
                      children={
                        <div
                          onClick={async (e) => {
                            e.preventDefault();
                            fetch(
                              `${process.env.REACT_APP_GATEWAY_URL}/getVoters?electionId=${election.id}`,
                              {
                                method: "GET",
                                headers: new Headers({
                                  "content-type": "application/json",
                                  "Request-Origin": "pisarnica",
                                  Authorization: "Bearer " + (await getAccessToken()),
                                }),
                                mode: "cors",
                                credentials: "include",
                              }
                            )
                              .then((response) => {
                                if (response.status === 200) {
                                  return response.blob();
                                } else {
                                  return response;
                                }
                              })
                              .then((file) => {
                                if (file.status) {
                                  message.toggle({
                                    title: t("modalMessage.titleRemark"),
                                    content:
                                      file.status +
                                      " - Dogodila se greška tijekom dohvaćanja migriranih članova",
                                    hideNo: true,
                                    yesLabel: t("modalMessage.okLabel"),
                                    onYes: () => {
                                      message.toggle({});
                                    },
                                  });
                                } else {
                                  const blob = window.URL.createObjectURL(file);
                                  const anchor = document.createElement("a");
                                  anchor.style.display = "none";
                                  anchor.href = blob;
                                  anchor.download = `${"Migrirani_clanovi"}.xls`;
                                  document.body.appendChild(anchor);
                                  anchor.click();
                                  window.URL.revokeObjectURL(blob);
                                }
                              });
                          }}
                        >
                          <Icon
                            style={{ color: "#4a4a4a" }}
                            path={mdiFileExportOutline}
                            size={1.2}
                          />
                        </div>
                      }
                    ></Tooltip>
                  </span>
                  {/* Pridruži glasača izborima ako je status: u planiranju, u planiranju - zakljucano */}
                  {election.generatedStatus.id === 1 || election.generatedStatus.id === 2 ? (
                    <span className="ml-3">
                      <Link
                        to={{
                          pathname: "/elections/add-new-voters",
                          state: {
                            id: election.id,
                            typeName: election.typeName,
                          },
                        }}
                      >
                        <Tooltip
                          content={"Pridruživanje glasača izborima"}
                          delay={"0"}
                          direction={"top"}
                          children={
                            <Icon
                              style={{ color: "#4a4a4a" }}
                              path={mdiAccountPlusOutline}
                              size={1.2}
                            />
                          }
                        ></Tooltip>
                      </Link>
                    </span>
                  ) : null}
                </div>
                <div className="is-size-6 is-flex is-align-items-center"></div>
                <div style={{ color: "#4a4a4a" }}>
                  {widgetDate - dateNow > 0 ? (
                    <div style={{ marginBottom: "0.13rem" }}>{countdownTitle}</div>
                  ) : null}
                  {/* Prikaži countdown widget ako je datum u buducnosti, inace je brojac pokvaren i ide u minus*/}
                  {widgetDate - dateNow > 0 && election.generatedStatus.id !== 5 ? (
                    <CountdownTimer
                      countdownTo={widgetDate}
                      setFetchElections={setFetchElections}
                      currentTimeOffset={currentTimeOffset}
                    />
                  ) : null}
                </div>
              </div>
            </div>
          </Link>
        </div>
      </div>
    );
  }
};

export default ActiveElectionsSummaryPanel;
